<template>
  <div class="no-linear">
    <div class="no-linha" :style="{ paddingLeft: no.nivel * 22 + 'px' }">
      <button
        v-if="no.filhos.length > 0"
        class="btn-expand"
        :class="{ expandido: aberto }"
        @click="aberto = !aberto"
        :title="aberto ? 'Recolher' : 'Expandir'"
      >
        <span class="material-icons">{{ aberto ? 'remove' : 'add' }}</span>
      </button>
      <span v-else class="btn-expand placeholder"></span>

      <button class="no-botao" @click="$emit('clicar', no.membroId)">
        <span class="bolinha" :style="{ background: corNivel(no.nivel) }">
          {{ iniciais(no.nomeMembro) }}
        </span>
        <span class="id-badge">#{{ no.membroId }}</span>
        <span class="nome">{{ no.nomeMembro }}</span>
        <code>{{ no.codigoIndicacao }}</code>
        <span class="badge-filhos" v-if="no.filhos.length > 0">
          {{ no.filhos.length }} {{ no.filhos.length === 1 ? 'indicado' : 'indicados' }}
        </span>
      </button>
    </div>

    <div v-if="aberto && no.filhos.length > 0" class="filhos">
      <NoLinear
        v-for="filho in no.filhos"
        :key="filho.membroId"
        :no="filho"
        @clicar="(id) => $emit('clicar', id)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue'

const props = defineProps({
  no: { type: Object, required: true },
  expandidoInicial: { type: Boolean, default: false },
})
defineEmits(['clicar'])

const aberto = ref(props.expandidoInicial || props.no.nivel <= 1)

function iniciais(nome) {
  if (!nome) return '?'
  const p = nome.trim().split(/\s+/)
  return (p.length === 1 ? p[0].substring(0, 2) : p[0][0] + p[p.length - 1][0]).toUpperCase()
}

function corNivel(nivel) {
  const cores = ['#4f46e5', '#7c3aed', '#F7941D', '#22c55e', '#ec4899', '#06b6d4', '#84cc16']
  return cores[nivel % cores.length]
}
</script>

<style scoped>
.no-linear { position: relative; }
.no-linha {
  display: flex; align-items: center; gap: 6px;
  padding: 4px 0; border-bottom: 1px dashed #f1f5f9;
}

.btn-expand {
  width: 22px; height: 22px; border-radius: 4px; border: 1px solid #cbd5e1;
  background: #fff; color: #475569; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
  padding: 0; flex-shrink: 0;
}
.btn-expand .material-icons { font-size: 16px; }
.btn-expand:hover { background: #4f46e5; color: #fff; border-color: #4f46e5; }
.btn-expand.expandido { background: #4f46e5; color: #fff; border-color: #4f46e5; }
.btn-expand.placeholder {
  background: transparent !important; border: none !important;
  cursor: default; pointer-events: none;
}

.no-botao {
  flex: 1; background: transparent; border: none; cursor: pointer;
  display: flex; align-items: center; gap: 10px; padding: 6px 10px;
  border-radius: 6px; text-align: left;
}
.no-botao:hover { background: #f1f5f9; }

.bolinha {
  width: 30px; height: 30px; border-radius: 50%; color: #fff;
  font-weight: 700; font-size: 0.75rem; display: inline-flex;
  align-items: center; justify-content: center; flex-shrink: 0;
}
.id-badge {
  background: #e2e8f0; color: #475569; padding: 2px 6px; border-radius: 4px;
  font-size: 0.72rem; font-weight: 700; font-family: monospace;
}
.nome { flex: 1; font-weight: 500; color: #334155; font-size: 0.92rem; }
code {
  background: #f1f5f9; padding: 2px 6px; border-radius: 4px;
  font-size: 0.78rem; color: #64748b;
}
.badge-filhos {
  background: #dbeafe; color: #1e40af; padding: 2px 8px; border-radius: 10px;
  font-size: 0.7rem; font-weight: 600; white-space: nowrap;
}
</style>
